import { createActionGroup, props } from '@ngrx/store';
import { Preference } from '../models';

export const PreferenceActions = createActionGroup({
    source: 'Preferences',
    events: {
        'Patch Preference': props<Partial<Preference>>()
    }
});
